<template>
    <a 
      target="_blank"
      :href="door.ExternalLink"
      class="door"
      :class="{
        active: door,
        animate: animate
      }"
    >
      <div class="knob"></div>  
    </a>
</template>

<script>
export default {
  name: "Door",
  props: [
    'door'
  ],
  mounted() {
    setInterval(() => {this.animate = !this.animate}, 39000)
  },
  data () {
    return {
      animate: false
    }
  },
}
</script>

<style>
a.door {
  cursor: default;
}
a.door:hover {
  cursor: default;
}
a.door.active {
  cursor: pointer;
}
a.door.active .knob {
  transform-origin: top right;
  transition: transform 0.1s ease;
}
a.door.active:hover {
  cursor:pointer;
}
a.door.active:hover .knob {
  transform: rotate(-20deg);
  transition: transform 0.5s ease;
}
a.door.active.animate .knob {
  animation: 2s ease alternate openDoor;
}
@keyframes openDoor {
  0% { transform: none }
  50% { transform: rotate(-20deg) }
  100% { transform: none }
}
</style>


